import React, { useEffect } from 'react';

import { ConfigProvider, App, message } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';

import { antTheme } from '../antTheme';

const ConfigProviderAntd: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    message.config({
      top: 72,
      duration: 5,
      maxCount: 4,
    });
  }, []);

  return (
    <ConfigProvider locale={ptBR} theme={antTheme}>
      <App>{children}</App>
    </ConfigProvider>
  );
};

export default ConfigProviderAntd;
